"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sendable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var faTrash_1 = require("@fortawesome/pro-solid-svg-icons/faTrash");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_1 = require("react");
var PreviewAction_1 = require("./PreviewAction");
var utils_1 = require("utils");
var Progress_1 = require("./Progress");
var CONTAINER_STYLES = "flex relative w-full flex-grow";
var Sendable = function (_a) {
    var deletable = _a.deletable, preview = _a.preview, onDelete = _a.onDelete, progress = _a.progress, children = _a.children, listMode = _a.listMode;
    var _b = (0, react_1.useState)(false), hovering = _b[0], setHovering = _b[1];
    var _c = (0, react_1.useState)(null), hoverTimeout = _c[0], setHoverTimeout = _c[1];
    var deletePreview = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (onDelete) {
            onDelete(preview);
        }
    };
    var toggleHover = function (enabled) { return function () {
        if (hoverTimeout && enabled) {
            clearTimeout(hoverTimeout);
        }
        if (!enabled) {
            setHoverTimeout(setTimeout(function () { return setHovering(enabled); }, 25));
        }
        else {
            setHovering(enabled);
        }
    }; };
    var deleteVisible = !deletable && hovering ? true : false;
    var loading = progress && progress < 100;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: CONTAINER_STYLES, onMouseOver: toggleHover(true), onMouseOut: toggleHover(false), onMouseDown: toggleHover(false) }, { children: [onDelete ? ((0, jsx_runtime_1.jsx)(PreviewAction_1.PreviewAction, __assign({ onClick: deletePreview, onMouseOver: toggleHover(true), visible: deleteVisible, verticallyCentered: listMode }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faTrash_1.faTrash }, void 0) }), void 0)) : ((0, jsx_runtime_1.jsx)("span", {}, void 0)), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, utils_1.concatStyles)([
                    CONTAINER_STYLES,
                    loading ? "opacity-50" : "",
                ]) }, { children: children }), void 0), loading ? (0, jsx_runtime_1.jsx)(Progress_1.Progress, { progress: progress }, void 0) : null] }), void 0));
};
exports.Sendable = Sendable;
